"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const overdue_1 = __importDefault(require("../../api/overdue"));
const DescriptionList_vue_1 = __importDefault(require("./../DescriptionList.vue"));
const location_1 = require("../../select/location");
const dict_1 = require("../../select/dict");
exports.default = (0, vue_1.defineComponent)({
    name: 'DealerDetail',
    components: {
        DescriptionList: DescriptionList_vue_1.default
    },
    props: {
        id: {
            type: String,
            required: true
        },
        extraData: {
            type: Object,
            required: false
        },
    },
    data() {
        return {
            detail: null,
            description: [
                {
                    name: '经销商名称',
                    prop: 'enterprisename'
                },
                {
                    name: 'SAP编码',
                    prop: 'customerid'
                },
                {
                    name: '证件号码',
                    prop: 'certid'
                },
                {
                    name: '业务区域',
                    prop: 'area',
                    format(value) {
                        return dict_1.dict.area.getItem(value).label;
                    }
                },
                {
                    name: '省份',
                    prop: 'provincecode'
                },
                {
                    name: '城市',
                    prop: 'citycode'
                },
                {
                    name: '详细地址',
                    prop: 'districtcode'
                },
                {
                    name: '是否一级经销商',
                    prop: 'isonedistributor',
                    format(value) {
                        return value === 'Y' ? '是' : '否';
                    }
                }
            ]
        };
    },
    watch: {
        id: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.getDetail();
                }
            }
        }
    },
    methods: {
        getDetail() {
            if (this.id) {
                overdue_1.default.overdueDealerInfo.require({
                    orgCustomerid: this.id
                }).then((res) => {
                    const detail = res.data.data;
                    const provincecode = detail.provincecode;
                    const provinceValue = location_1.location.getItem(provincecode);
                    detail.provincecode = provinceValue.label;
                    if (detail.citycode && provinceValue.children && /^\d+$/.test(detail.citycode)) {
                        const citycode = detail.citycode;
                        for (let i = 0; i < provinceValue.children.length; i++) {
                            const cityValue = provinceValue.children[i];
                            if (cityValue.value === citycode) {
                                detail.citycode = cityValue.label;
                                break;
                            }
                        }
                    }
                    this.detail = detail;
                });
            }
        }
    }
});
